(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nt7east-smart-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function getHistory() {
      try {
        var raw = localStorage.getItem('nt7_view_history');
        var parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    }

    function scoreCard(card, history) {
      var tags = (card.dataset.tags || '').split(',').filter(Boolean);
      var collections = (card.dataset.collections || '').split(',').filter(Boolean);
      var unitsSold = parseInt(card.dataset.unitsSold, 10) || 0;
      var tagHits = 0;
      var collectionHits = 0;

      history.forEach(function (entry) {
        (entry.tags || []).forEach(function (tag) {
          if (tags.indexOf(tag) !== -1) tagHits += 1;
        });
        (entry.collections || []).forEach(function (handle) {
          if (collections.indexOf(handle) !== -1) collectionHits += 1;
        });
      });

      var salesScore = Math.log(unitsSold + 1);
      var randomScore = Math.random();

      return tagHits * 3 + collectionHits * 4 + salesScore * 1.5 + randomScore * 4;
    }

    function initRibbon(root) {
      if (root.dataset.nt7RecoInit) return;
      root.dataset.nt7RecoInit = 'true';

      var track = root.querySelector('[data-nt7-reco-track]');
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-nt7-reco-card]'));
      if (!track || !cards.length) return;

      var visibleCount = parseInt(root.dataset.visibleCount, 10) || 10;
      var history = getHistory();

      var scored = cards.map(function (card) {
        return { card: card, score: scoreCard(card, history) };
      });
      scored.sort(function (a, b) {
        return b.score - a.score;
      });

      var chosen = scored.slice(0, Math.min(visibleCount, scored.length));
      var discarded = scored.slice(visibleCount);

      chosen.forEach(function (item) {
        item.card.hidden = false;
        track.appendChild(item.card);
      });
      discarded.forEach(function (item) {
        item.card.remove();
      });

      var prevBtn = root.querySelector('[data-nt7-reco-prev]');
      var nextBtn = root.querySelector('[data-nt7-reco-next]');

      function step() {
        return Math.max(track.clientWidth * 0.8, 160);
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }

      if (root.dataset.autoscroll === 'true' && chosen.length > 1) {
        var speed = parseFloat(root.dataset.autoscrollSpeed) || 30;
        var paused = false;
        var lastTimestamp = null;

        track.addEventListener('mouseenter', function () {
          paused = true;
        });
        track.addEventListener('mouseleave', function () {
          paused = false;
        });
        track.addEventListener(
          'touchstart',
          function () {
            paused = true;
          },
          { passive: true }
        );
        track.addEventListener(
          'touchend',
          function () {
            window.setTimeout(function () {
              paused = false;
            }, 2500);
          },
          { passive: true }
        );

        function tick(timestamp) {
          if (lastTimestamp === null) lastTimestamp = timestamp;
          var deltaSeconds = (timestamp - lastTimestamp) / 1000;
          lastTimestamp = timestamp;

          if (!paused && track.scrollWidth > track.clientWidth) {
            var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
            if (atEnd) {
              track.scrollLeft = 0;
            } else {
              track.scrollLeft += speed * deltaSeconds;
            }
          }

          window.requestAnimationFrame(tick);
        }

        window.requestAnimationFrame(tick);
      }
    }

    document.querySelectorAll('[data-nt7-smart-reco]').forEach(initRibbon);
  })();

  } catch(e) { console.error(e); }
})();
})();
